import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SERVICES,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';

import { attachmentsOrigins } from '../../domains/attachments/constants';
import { ApiRequestDescriptor } from '../../services';

const { EXTERNAL_CARRIER_LABEL_ATTACHMENT } = attachmentsOrigins;

const EXTERNAL_CARRIER_LABEL_ENDPOINT =
  `${APIConfiguration.carrier}externalCarrierDepositLabels/${COMMON_QUERY_PARAMS.FILE_ATTACHMENT_ID}`;
const FILE_ATTACHMENT_ENDPOINT =
  `${APIConfiguration.document}files/${COMMON_QUERY_PARAMS.FILE_ID}/` +
  `${COMMON_QUERY_PARAMS.SERVICE}-attachments/${COMMON_QUERY_PARAMS.FILE_ATTACHMENT_ID}`;

export interface DeleteFileAttachmentRequestArgs {
  fileId: string;
  fileAttachmentId: string;
  service?: string;
  type?: string;
}

export const deleteFileAttachmentRequest = ({
  fileId,
  fileAttachmentId,
  service,
  type,
}: DeleteFileAttachmentRequestArgs): ApiRequestDescriptor => {
  const env = service || SERVICES.MYACCOUNT;

  if (type === EXTERNAL_CARRIER_LABEL_ATTACHMENT) {
    return {
      url: EXTERNAL_CARRIER_LABEL_ENDPOINT.replace(
        COMMON_QUERY_PARAMS.FILE_ATTACHMENT_ID,
        fileAttachmentId,
      ),
      config: { method: SUPPORTED_METHODS.DELETE },
    };
  }

  return {
    url: FILE_ATTACHMENT_ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId)
      .replace(COMMON_QUERY_PARAMS.SERVICE, env)
      .replace(COMMON_QUERY_PARAMS.FILE_ATTACHMENT_ID, fileAttachmentId),
    config: { method: SUPPORTED_METHODS.DELETE },
  };
};
